import type { RefereeType } from '.'

export type EditRefereeErrors =
  | 'RefereeRequestHasInvalidEmail'
  | 'RequestDoesNotContainDifferentPropertiesToCurrentSubject'
  | 'GenericError'

export const errorCodesToMessages: Record<EditRefereeErrors, string> = {
  RefereeRequestHasInvalidEmail: 'The email address is invalid',
  RequestDoesNotContainDifferentPropertiesToCurrentSubject: 'No changes were made',
  GenericError:
    'Failed to update referee details. Please retry in a few minutes and contact support if issues persist.',
}

export const refereeTypeToUrl: Record<RefereeType, string> = {
  landlord: '/landlord-referee',
  employer: '/employer-referee',
  accountant: '/accountant-referee',
}
